(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hp-character-guide"]) return;
  try {
    
function initHpHelp(root){if(root.dataset.ready)return;root.dataset.ready='true';const close=()=>{root.open=false;root.querySelector('summary').focus();};root.querySelector('[data-help-close]').addEventListener('click',close);root.addEventListener('keydown',e=>{if(e.key==='Escape'&&root.open){e.preventDefault();close();}});document.addEventListener('click',e=>{if(root.open&&!root.contains(e.target))root.open=false;});}document.querySelectorAll('[data-hp-help]').forEach(initHpHelp);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hp-help]').forEach(initHpHelp));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-kids-editorial-home"] && !Shopify.designMode) return;
  try {
    
function initHpMotion(){
 const bar=document.querySelector('[data-hp-reading]');if(!bar||bar.dataset.ready)return;bar.dataset.ready='true';let pending=false;
 function update(){pending=false;const height=document.documentElement.scrollHeight-innerHeight;bar.style.transform='scaleX('+(height>0?Math.min(1,Math.max(0,scrollY/height)):0)+')';}
 addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});addEventListener('resize',update);update();
 document.querySelectorAll('.hp-chapter-nav a').forEach(a=>a.addEventListener('click',()=>a.closest('details').open=false));
 if(!matchMedia('(prefers-reduced-motion: reduce)').matches&&'IntersectionObserver' in window){
 const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting){entry.target.animate([{opacity:.5,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],{duration:420,easing:'ease-out'});observer.unobserve(entry.target);}}),{threshold:.12});
 document.querySelectorAll('.hp-kids-editorial__card,.hp-kids-editorial__book,.hp-office header').forEach(el=>observer.observe(el));
 }
}
initHpMotion();document.addEventListener('shopify:section:load',initHpMotion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hp-kids-office"] && !Shopify.designMode) return;
  try {
    
function initHpOffice(root){
 if(root.dataset.ready)return; root.dataset.ready='true';
 const links=[...root.querySelectorAll('[data-desk]')],panels=[...root.querySelectorAll('[data-panel]')];
 const nav=root.querySelector('.hp-office__tabs');nav.setAttribute('role','tablist');
 links.forEach(link=>{link.setAttribute('role','tab');link.id='tab-'+link.getAttribute('href').slice(1);link.setAttribute('aria-controls',link.getAttribute('href').slice(1));});
 panels.forEach(panel=>{panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby','tab-'+panel.id);panel.tabIndex=0;});
 function activate(key,focus){if(!links.some(l=>l.dataset.desk===key))key='liza';links.forEach(l=>{const on=l.dataset.desk===key;l.setAttribute('aria-selected',String(on));l.tabIndex=on?0:-1;});panels.forEach(p=>p.hidden=p.dataset.panel!==key);if(focus)links.find(l=>l.dataset.desk===key).focus();}
 links.forEach((link,index)=>{link.addEventListener('click',e=>{e.preventDefault();activate(link.dataset.desk,false);});link.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(index+1)%links.length;if(e.key==='ArrowLeft')next=(index+links.length-1)%links.length;if(e.key==='Home')next=0;if(e.key==='End')next=links.length-1;if(next!==undefined){e.preventDefault();activate(links[next].dataset.desk,true);}});});
 root.querySelectorAll('[data-say]').forEach(button=>{let index=-1;button.addEventListener('click',()=>{const lines=[...button.closest('[data-speech]').querySelectorAll('[data-line]')];index=(index+1)%lines.length;lines.forEach((line,i)=>line.hidden=i!==index);});});
 const learned=new Set();root.querySelectorAll('[data-word]').forEach((word,index)=>word.addEventListener('toggle',()=>{if(word.open){learned.add(index);root.querySelector('[data-word-count]').textContent=String(learned.size);}}));
 const deepLink=new URLSearchParams(location.search).get('character');activate(deepLink||'liza',false);
 root.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-mode-copy]').forEach(p=>p.hidden=p.dataset.modeCopy!==button.dataset.mode);}));
 root.querySelector('[data-finder]').addEventListener('submit',e=>{e.preventDefault();activate(e.currentTarget.elements.character.value,true);root.querySelectorAll('[data-context-note]').forEach(p=>p.hidden=p.dataset.contextNote!==e.currentTarget.elements.context.value);});
 const coins=root.querySelector('[data-coins]');
 const total=()=>[...coins.querySelectorAll('input')].reduce((n,input)=>n+(Number(input.value)||0),0);
 function clearBudget(){root.querySelectorAll('[data-budget]').forEach(p=>p.hidden=true);}
 coins.addEventListener('input',()=>{root.querySelector('[data-total]').textContent=total();clearBudget();});
 coins.addEventListener('submit',e=>{e.preventDefault();if(!coins.reportValidity())return;const sum=total();const key=sum>10?'over':sum<10?'under':'balanced';root.querySelectorAll('[data-budget]').forEach(p=>p.hidden=p.dataset.budget!==key);});
 coins.addEventListener('reset',()=>{clearBudget();root.querySelector('[data-total]').textContent='10';});
 root.querySelectorAll('[data-palette]').forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.palette;root.querySelector('.hp-office__palette').dataset.colour=key;root.querySelectorAll('[data-palette]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));root.querySelectorAll('[data-palette-note]').forEach(p=>p.hidden=p.dataset.paletteNote!==key);}));
 root.querySelectorAll('[data-answer]').forEach(button=>button.addEventListener('click',()=>{const quiz=button.closest('[data-quiz]');quiz.querySelectorAll('[data-feedback]').forEach(p=>p.hidden=p.dataset.feedback!==button.dataset.answer);}));
}
document.querySelectorAll('[data-hp-office]').forEach(initHpOffice);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hp-office]').forEach(initHpOffice));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
